module.exports = __webpack_public_path__ + "static/media/AI_handshake.639d7868.webp";